<div class="dialog-header">
  <h6 matDialogTitle>Upload Image Details</h6>
  <button
    class="close-button"
    bciprimarybutton
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <mat-tab-group
    class=""
    dynamicHeight
    [(selectedIndex)]="activeTabIndex"
    (selectedTabChange)="navigate($event)"
  >
    <mat-tab>
      <ng-template mat-tab-label>Upload Image</ng-template>
      <form [formGroup]="formData" #formDirective="ngForm" novalidate>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-lg-2 col-sm-2">
              <mat-label class="label-input">Selected Entity</mat-label>
            </div>
            <div class="col-lg-3 col-sm-3">
              <mat-form-field>
                <input
                  type="text"
                  matInput
                  formControlName="loadnameCtr"
                  [(ngModel)]="selectedEntityName"
                  name="loadname"
                  id="loadname"
                  readonly
                />
              </mat-form-field>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-2 col-sm-2">
              <mat-label class="label-input">Choose file to upload</mat-label>
            </div>
            <div class="col-lg-3 col-sm-3">
              <input
                type="file"
                id="uploadImage"
                (change)="uploadDocument($event, 'ClickAndNavigateLayout')"
                class="hidden"
                accept=".jpeg,.jpg,.png,.jpe,image/jpeg,image/png"
              />
              <button
                type="button"
                bciprimarybutton
                class="button-primary"
                (click)="selectDocument('uploadImage')"
                matTooltip="Select picture (860*650)"
                style="margin-top: 1em"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="edit icon"
                    class="bosch-ic-paperclip"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div>
            <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
              <div id="wrapper" style="text-align: center; width: 100%">
                <canvas id="loadImgCanvas" width="0" height="0"></canvas>
              </div>
            </div>
          </div>
        </div>
        <br />
        <mat-divider></mat-divider>
        <div class="row" style="text-align: center"></div>
        <br />
      </form>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>Info</ng-template>

      <br /><br />
      <div class="col-md-4 text-right padding-1">Selected Entity Name</div>
      <div class="input-group col-lg-5 col-sm-5">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="selectedEntityName"
          name="loadname"
          id="loadname"
          readonly
        />
        <br /><br /><br />
      </div>

      <div class="col-md-4 text-right padding-1">Typ.Occupancy</div>
      <div class="input-group col-lg-5 col-sm-5">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="tagParameters.loadName"
          name="loadname"
          id="loadname"
        />
        <br /><br /><br />
      </div>

      <div class="col-md-4 text-right padding-1">Area (in Sq.ft)</div>
      <div class="input-group col-lg-5 col-sm-5">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="tagParameters.loadName"
          name="loadname"
          id="loadname"
        />
        <br /><br /><br />
      </div>
      <mat-divider></mat-divider>
      <div class="input-group col-lg-12 col-sm-12" style="text-align: center">
        <button
          type="submit"
          bciprimarybutton
          class="button-primary"
          [disabled]="submitted"
          style="margin-top: 1em"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-checkmark-frame"
              style="width: max-content"
            ></mat-icon> </span
          >Submit
        </button>
        <button
          type="submit"
          bciprimarybutton
          class="button-primary"
          style="margin-top: 1em; margin-left: 3px"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-edit"
              style="width: max-content"
            ></mat-icon> </span
          >Edit
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <button
    type="button"
    class="btn mat-raised-button pull-right alignClose"
    bciprimarybutton
    (click)="close(false)"
    style="margin: 1em"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn mat-raised-button pull-right"
    bciprimarybutton
    (click)="submitUploadImageDetails()"
    style="margin: 1em 0"
    [disabled]="submitted"
  >
    <span>
      <mat-icon
        aria-hidden="false"
        aria-label="edit icon"
        class="bosch-ic-checkmark-frame"
        style="width: max-content"
      >
      </mat-icon> </span
    >Submit
  </button>
</mat-dialog-footer>
